import React, { useState, useMemo } from "react";
import { FaBaby } from "react-icons/fa";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";

// Default newborn data
const NEWBORN_DATA = [
	{ label: "Weight less than 2500 gms", value: 42990 },
	{ label: "Received 6 HBNC after ID", value: 109615 },
	{ label: "Breast fed within 1 hour of birth", value: 279819 },
];

// Dummy previous period values (80% of current)
function generatePreviousData(data) {
	return data.map((d) => ({
		...d,
		value: Math.round(d.value * 0.92),
	}));
}

export default function NewBornCard({ selectedDistrict = null, seed = 0 }) {
	const [open, setOpen] = useState(false);

	// Current period data
	const currentData = useMemo(() => {
		if (!selectedDistrict) return NEWBORN_DATA;
		return NEWBORN_DATA.map((d) => ({
			...d,
			value: Math.round(d.value * 0.2),
		}));
	}, [selectedDistrict, seed]);

	const previousData = generatePreviousData(currentData);

	// Totals
	const totalCurrent = currentData.reduce((sum, d) => sum + d.value, 0);
	const totalPrevious = previousData.reduce((sum, d) => sum + d.value, 0);

	// Comparison %
	const diff = totalCurrent - totalPrevious;
	const percentage = (diff / totalPrevious) * 100;
	const isIncrease = diff >= 0;

	return (
		<>
			{/* Small card */}
			<button
				onClick={() => setOpen(true)}
				className="inline-flex items-center gap-3 px-3 py-2 rounded-lg shadow-sm bg-white border hover:shadow-md w-full"
			>
				<div className="w-10 h-10 flex items-center justify-center rounded-md bg-indigo-100">
					<FaBaby className="text-indigo-600 w-5 h-5" />
				</div>

				<div className="text-left">
					<div className="text-xs text-slate-500">Total New Born</div>

					<div className="flex items-center gap-2">
						<div className="text-lg font-semibold">
							{totalCurrent.toLocaleString()}
						</div>
						
						{/* Always show comparison */}
						{/* <div
							className={`flex items-center text-xs font-semibold ${isIncrease ? "text-green-600" : "text-red-600"
								}`}
						>
							{isIncrease ? (
								<FaArrowUp className="w-3 h-3" />
							) : (
								<FaArrowDown className="w-3 h-3" />
							)}
							{Math.abs(percentage).toFixed(1)}%
						</div> */}
					</div>
					<div className="text-[11px] mt-0.5">
							<span className="text-red-600">
								{isIncrease ? "▼" : "▲"} {Math.abs(percentage).toFixed(1)}%
							</span>
							<span className="text-slate-500"> vs previous period</span>
						</div>

					{/* <div className="text-[10px] text-slate-400">vs previous period</div> */}
				</div>
			</button>

			{/* Drawer */}
			{open && (
				<div className="fixed inset-0 z-50 flex">
					<div
						className="absolute inset-0 bg-black/40"
						onClick={() => setOpen(false)}
					/>

					<aside className="relative ml-auto w-full max-w-lg h-full bg-white shadow-xl overflow-auto">
						<div className="p-4 border-b flex items-start justify-between">
							<div>
								<h3 className="text-lg font-semibold">New Born Details</h3>
								<p className="text-xs text-slate-500">
									Source: HMIS-Apr24 to Mar25
								</p>
							</div>

							<button
								onClick={() => setOpen(false)}
								className="px-3 py-1 rounded bg-slate-100 text-sm"
							>
								Close
							</button>
						</div>

						<div className="p-4 space-y-4">
							{currentData.map((d, i) => (
								<div
									key={d.label}
									className="p-3 bg-white rounded-lg border shadow-sm"
								>
									<div className="text-sm text-slate-500">{d.label}</div>

									<div className="flex items-center gap-2 mt-1">
										<div className="text-xl font-bold">
											{d.value.toLocaleString()}
										</div>

										{/* Row-level comparison */}
										{(() => {
											const prev = previousData[i].value;
											const diff = d.value - prev;
											const pct = (diff / prev) * 100;
											const inc = diff >= 0;

											return (
												<span
													className={`flex items-center text-xs font-semibold ${inc ? "text-green-600" : "text-red-600"
														}`}
												>
													{inc ? (
														<FaArrowUp className="w-3 h-3" />
													) : (
														<FaArrowDown className="w-3 h-3" />
													)}
													{Math.abs(pct).toFixed(1)}%
												</span>
											);
										})()}
									</div>
								</div>
							))}
						</div>
					</aside>
				</div>
			)}
		</>
	);
}
